import { html, unsafeHTML } from '@oskecare/fe-utilities/lib/LitElement/index.js';

/**
 * @param {string} heading
 * @returns {TemplateResult}
 */
export default function renderHeader(heading) {
  return html`
    <div class="section bg-black section--xsmall">
      <div class="container">
        <h1 class="display-1">${unsafeHTML(heading)}</h1>
      </div>
    </div>
  `;
}
